// extracted by mini-css-extract-plugin
export default {"componentWrapper":"StatusPill_componentWrapper__llnJF","active":"StatusPill_active__Q+J3f","pending":"StatusPill_pending__MzT5y","inactive":"StatusPill_inactive__UDpN7"};